export default __webpack_public_path__ + "pgnv-assets/f3e098c74e3f7badde09d43bf489dd74.png";